export const demoLineData = [
	{
		x: 1,
		y: 2,
	},
	{
		x: 2,
		y: 2,
	},
	{
		x: 3,
		y: 2,
	},
	{
		x: 4,
		y: 2,
	},
	{
		x: 5,
		y: 2,
	},
	{
		x: 6,
		y: 3,
	},
	{
		x: 7,
		y: 3,
	},
	{
		x: 8,
		y: 3,
	},
	{
		x: 9,
		y: 3,
	},
	{
		x: 10,
		y: 2,
	},
	{
		x: 11,
		y: 1,
	},
	{
		x: 12,
		y: 1,
	},
	{
		x: 13,
		y: 1,
	},
	{
		x: 14,
		y: 1,
	},
	{
		x: 15,
		y: 1,
	},
	{
		x: 16,
		y: 1,
	},
	{
		x: 17,
		y: 1,
	},
	{
		x: 18,
		y: 3,
	},
	{
		x: 19,
		y: 3,
	},
	{
		x: 20,
		y: 3,
	},
];
